import { add } from "./base";
import { phonePrefix } from "./phonePrefix";
class Handler {
    toString(data) {
        return typeof data == "string" ? data : "";
    }
    fromString(value) {
        return typeof value == "string" && !!value ? value : undefined;
    }
    partialFormat = this.format;
    format(unformatted) {
        let result = unformatted;
        if (result.value.startsWith("+")) {
            for (const country of phonePrefix)
                if (result.value.startsWith(country.countryCode))
                    for (let prefix of country.areaCodes) {
                        prefix = prefix.substring(1);
                        if (result.value.startsWith(country.countryCode + prefix) && !result.value.includes("-"))
                            result = result
                                .insert(country.countryCode.length, "-")
                                .insert(country.countryCode.length + 1 + prefix.length, "-");
                    }
        }
        else {
            const first = phonePrefix[0];
            for (const prefix of first.areaCodes)
                if (result.value.startsWith(prefix) && !result.value.includes("-")) {
                    result = result.insert(prefix.length, "-");
                    result = result.delete(0);
                    result = result.insert(0, "-").insert(0, first.countryCode);
                }
        }
        if (result.value.includes("-")) {
            const digitIndex = result.value.indexOf("-", result.value.indexOf("-") + 1) + 1;
            const digitCount = result.value.substring(digitIndex, result.value.length + 1).length;
            switch (digitCount) {
                case 4:
                    result = result.insert(digitIndex + 2, " ");
                    break;
                case 5:
                    result = result.insert(digitIndex + 3, " ");
                    break;
                case 6:
                    result = result.insert(digitIndex + 2, " ");
                    result = result.insert(digitIndex + 5, " ");
                    break;
                case 7:
                    result = result.insert(digitIndex + 3, " ");
                    result = result.insert(digitIndex + 6, " ");
                    break;
                case 8:
                case 9:
                    result = result.insert(digitIndex + 3, " ");
                    result = result.insert(digitIndex + 7, " ");
                    break;
                default:
                    break;
            }
            if (digitCount > 9) {
                const spaces = Math.ceil(digitCount / 3) - 1;
                if (spaces > 0) {
                    for (let i = 0; i < spaces; i++) {
                        const position = i * 3 + 3 + i;
                        result = result.insert(position + digitIndex, " ");
                    }
                }
            }
        }
        return { ...result, type: "tel", autocomplete: "tel" };
    }
    unformat(formatted) {
        return formatted.delete(" ").delete("-");
    }
    allowed(symbol, state) {
        return ((symbol >= "0" && symbol <= "9") || (state.selection.start == 0 && symbol == "+" && !state.value.includes("+")));
    }
}
add("phone", () => new Handler());
//# sourceMappingURL=phone.js.map